import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SMAppLicense: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'title': t('t241'),
            'content': t('t242'),
        },
        {
            'title': t('t243'),
            'content': t('t244'),
        },
        {
            'title': t('t245'),
            'content': t('t246'),
        },
        {
            'title': t('t247'),
            'content': t('t248'),
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Grid item key={index} xs={12}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400}>
                        {data[index]['title']}
                    </Typography>
                    <Typography color={'#6B6B6B'} fontSize={16} fontWeight={700}>
                        {data[index]['content']}
                    </Typography>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '40px',
                paddingBottom: '40px',
            }}
        >
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '10px',
                paddingLeft: '40px',
                paddingRight: '40px',
                paddingTop: '50px',
                paddingBottom: '50px',
                boxShadow: '0px 10px 80px 3px #0000001A',
            }}>
                <Grid container rowSpacing={2}>
                    {data.map((item, index) => (
                        renderItem(index)
                    ))}
                </Grid>

                <Typography color={'#6B6B6B'} fontSize={16} fontWeight={600} paddingTop={'40px'} paddingLeft={'12px'} paddingRight={'12px'}>
                    {t('t249')}
                </Typography>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMAppLicense
